// Validations
$(function () {
  /* This code is handling the form submission for creating a new customer. It is checking if the
password and password confirmation fields match, and if the "agree_terms" checkbox is checked. If
either of these conditions are not met, it prevents the form from submitting and displays an error
message. It also sets a timeout to fade out the error message after 3 seconds. */
  $("#create_customer").submit(function (e) {
    if (
      $('input[name="customer[password]"]').val() !=
      $('input[name="customer[password_confirmation]"]').val()
    ) {
      e.preventDefault();
      $("#setErrorMessage").html(
        "<u>The passwords must match in order to continue.</u>"
      );
      $("#custom-error-message").show();
    }
    if (!$('input[name="customer[agree_terms]"]').is(":checked")) {
      e.preventDefault();
      $("#setErrorMessage").html(
        "You must <u>Read And Accepted The Terms Of Use And Privacy Policy</u>"
      );
      $("#custom-error-message").show();
    }
    setTimeout(() => {
      $("#custom-error-message").fadeOut(2000, "easeInOutQuint");
    }, "3000");
  });

  /* This code is adding a click event listener to the elements with IDs "forgetButton" and
"cancelButton". When either of these buttons is clicked, the element with ID "recoverPasswordError"
will be hidden with a slow animation. */
  $("#forgetButton,#cancelButton").click(function () {
    $("#recoverPasswordError").hide("slow");
  });
});
// Handlers
/**
 * The function changes the active tab and indicator position based on user input and updates local
 * storage.
 * @param e - The event object that triggered the function (e.g. a click event on a tab element).
 * @param id - The `id` parameter is a value that represents the ID of the tab that is being changed
 * to. It is used to identify which tab item should be made active and which should be inactive. It is
 * also used to set a value in local storage to remember which tab was last active when the page
 */
function changeTabs(e, id) {
  const tabs = document.querySelectorAll(".custom-tabs .tab");
  const indicator = document.getElementById("custom-tab-indicator");
  for (const tab of tabs) {
    if (tab === e) {
      if (!tab.classList.contains("tab-active"))
        tab.classList.add("tab-active");
      indicator.style.width = `${tab.offsetMaxWidth}px`;
      indicator.style.left = `${tab.offsetLeft}px`;
      handleLocalStorage("set", "pageTab", id);
    } else tab.classList.remove("tab-active");
  }

  const tabItems = document.getElementsByClassName("custom-tabitem");
  for (const tab of tabItems) {
    const data_id = tab.getAttribute("data-tab-id");
    if (data_id === id) {
      if (!tab.classList.contains("tabitem-active"))
        tab.classList.add("tabitem-active");
    } else tab.classList.remove("tabitem-active");
  }
}
/**
 * This is a function that handles local storage operations such as getting, setting, and removing
 * items based on the type and event type provided.
 * @param type - The type of operation to perform on the local storage. It can be "get" to retrieve
 * data from local storage, "set" to store data in local storage, or "remove" to remove data from local
 * storage.
 * @param eventType - The eventType parameter is a string that represents the type of event being
 * stored in localStorage. It is used as the key to access the stored data in localStorage.
 * @param [eventData] - eventData is an optional parameter that can be passed to the handleLocalStorage
 * function. It represents the data that needs to be stored in the local storage when the type
 * parameter is set. If type is not set to "set", eventData will be ignored.
 * @returns The function is not returning anything in the "set" and "remove" cases. In the "get" case,
 * it returns the value stored in localStorage with the key equal to the eventType parameter.
 */
const handleLocalStorage = (type, eventType, eventData = "") => {
  const storageKey = `${eventType}`;

  switch (type) {
    case "get":
      return localStorage.getItem(storageKey);
    case "set":
      localStorage.setItem(storageKey, eventData);
      break;
    case "remove":
      localStorage.removeItem(storageKey);
      break;
    default:
      break;
  }
};
function changeTabOnResetPassword() {
  const resetBtn = document.querySelector(".recover-password .submitButton");
  resetBtn.addEventListener("click", () => {
    handleLocalStorage("set", "pageTab", "2");
  });
}
/**
 * The function handles the activation of tabs on a web page based on the existence of a stored page
 * tab value in local storage.
 */
function handleTabs() {
  const existsPageTab = Boolean(handleLocalStorage("get", "pageTab"));
  const pageTab = handleLocalStorage("get", "pageTab");
  const urlParams = new URLSearchParams(window.location.search);
  const templateLocated = "{{ template.name }}";

  if (existsPageTab) {
    const tabElement = document.getElementById(`tab-id-${pageTab}`);
    tabElement.classList.add("tabitem-active");
    pageTab > 1
      ? (document.getElementById("custom-tab-indicator").style.left = "50%")
      : null;
  } else {
    const tempActivationTab = templateLocated === "login" ? 2 : 1;
    tempActivationTab === 2
      ? (document.getElementById("custom-tab-indicator").style.left = "50%")
      : null;
    handleLocalStorage("set", "pageTab", tempActivationTab);
    document
      .getElementById(`tab-id-${tempActivationTab}`)
      .classList.add("tabitem-active");
  }

  if ((urlParams.get("register")||"").toLowerCase() === "true") {
    document.getElementById("custom-tab-indicator").style.left = "unset";
    document.getElementById(`tab-id-1`).classList.add("tabitem-active");
    document.getElementById(`tab-id-2`).classList.remove("tabitem-active");
  } else if ((urlParams.get("register")||"").toLowerCase() === "false") {
    document.getElementById("custom-tab-indicator").style.left = "50%";
    document.getElementById(`tab-id-1`).classList.remove("tabitem-active");
    document.getElementById(`tab-id-2`).classList.add("tabitem-active");
  }
}
changeTabOnResetPassword();
handleTabs();
